<template>
  <div class="ir-chip-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'IRChipGroup',
  props: {
    value: Array
  },
  data() {
    return {
      selectedChips: this.value.slice()
    };
  },
  watch: {
    value(newValue) {
      this.selectedChips = newValue.slice();
    }
  },
  mounted() {
    this.$children.forEach(child => {
      child.$on('update:selected', this.toggleSelection);
    });
  },
  methods: {
    toggleSelection(chipValue) {
      const index = this.selectedChips.indexOf(chipValue);
      if (index > -1) {
        this.selectedChips.splice(index, 1);
      } else {
        this.selectedChips.push(chipValue);
      }
      this.$emit('input', this.selectedChips.slice());
    }
  }
};
</script>

<style scoped>
.ir-chip-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
